(function () {
  if (window.tokboltSubscribeSaveBound) return;

  window.tokboltSubscribeSaveBound = true;

  function getSubscriptionContext(form) {
    if (!form || !form.matches || !form.matches('form')) return null;

    var planInput = form.querySelector('[data-tokbolt-subscription-plan]');
    var selector = form.querySelector('[data-tokbolt-subscription-selector]');
    var subscriptionToggle = form.querySelector('[data-tokbolt-subscription-toggle]');

    if (!planInput || !selector || !subscriptionToggle) return null;

    return {
      form: form,
      planInput: planInput,
      selector: selector,
      subscriptionToggle: subscriptionToggle,
    };
  }

  function choose(context, useSubscription) {
    var planId = context.selector.dataset.sellingPlanId || '';

    context.subscriptionToggle.checked = !!useSubscription;
    context.planInput.value = useSubscription ? planId : '';
    context.subscriptionToggle.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function submitWithChoice(context, useSubscription) {
    context.form.dataset.tokboltSubscriptionPromptBypass = 'true';
    choose(context, useSubscription);
    closePrompt();

    window.setTimeout(function () {
      if (typeof context.form.requestSubmit === 'function') {
        context.form.requestSubmit();
      } else {
        context.form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    }, 0);
  }

  function closePrompt() {
    var prompt = document.querySelector('[data-tokbolt-subscription-prompt]');

    if (!prompt) return;

    var trigger = prompt._tokboltTrigger;
    prompt.remove();
    document.body.classList.remove('tokbolt-subscribe-prompt-open');

    if (trigger && document.body.contains(trigger)) trigger.focus();
  }

  function showPrompt(context, trigger) {
    closePrompt();

    var prompt = document.createElement('div');
    prompt.className = 'tokbolt-subscribe-prompt';
    prompt.dataset.tokboltSubscriptionPrompt = 'true';
    prompt.innerHTML =
      '<div class="tokbolt-subscribe-prompt__dialog" role="dialog" aria-modal="true" aria-labelledby="TokboltSubscribePromptTitle">' +
        '<button class="tokbolt-subscribe-prompt__close" type="button" aria-label="Close">×</button>' +
        '<p class="tokbolt-subscribe-prompt__eyebrow">Save 15% every month</p>' +
        '<h2 id="TokboltSubscribePromptTitle">Wait! Don\'t lose your savings.</h2>' +
        '<p>Subscribe for delivery every 30 days and save 15% on every cleaner refill. You can pause or cancel anytime.</p>' +
        '<div class="tokbolt-subscribe-prompt__actions">' +
          '<button class="tokbolt-subscribe-prompt__confirm" type="button">Yes, Subscribe &amp; Save 15%</button>' +
          '<button class="tokbolt-subscribe-prompt__decline" type="button">No thanks, add once</button>' +
        '</div>' +
      '</div>';
    prompt._tokboltTrigger = trigger || document.activeElement;
    document.body.appendChild(prompt);
    document.body.classList.add('tokbolt-subscribe-prompt-open');

    prompt.querySelector('.tokbolt-subscribe-prompt__confirm').addEventListener('click', function () {
      submitWithChoice(context, true);
    });
    prompt.querySelector('.tokbolt-subscribe-prompt__decline').addEventListener('click', function () {
      submitWithChoice(context, false);
    });
    prompt.querySelector('.tokbolt-subscribe-prompt__close').addEventListener('click', closePrompt);
    prompt.addEventListener('click', function (event) {
      if (event.target === prompt) closePrompt();
    });
    prompt.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closePrompt();
    });

    prompt.querySelector('.tokbolt-subscribe-prompt__confirm').focus();
  }

  document.addEventListener('submit', function (event) {
    var context = getSubscriptionContext(event.target);

    if (!context) return;

    if (context.form.dataset.tokboltSubscriptionPromptBypass === 'true') {
      delete context.form.dataset.tokboltSubscriptionPromptBypass;
      return;
    }

    if (context.subscriptionToggle.checked && !context.subscriptionToggle.disabled) {
      choose(context, true);
    }

    if (context.planInput.value) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    showPrompt(context, event.submitter || document.activeElement);
  }, true);

})();
